import DataMapper from './DataMapper'
import ClaimTypeDataMapper from './ClaimTypeDataMapper'
import UserDataMapper from './UserDataMapper'
import CaseTypeDataMapper from './CaseTypeDataMapper'
import URLResource from '../../models/URLResource'
import ClientRM from '../responsemodel/ClientRM'
import Client from '../../models/Client'
import BranchDataMapper from './BranchDataMapper'
import CaseType from '../../models/CaseType'

class ClientDataMapper extends DataMapper<ClientRM, Client> {
  private userDataMapper = new UserDataMapper()
  private claimTypeDataMapper = new ClaimTypeDataMapper()
  private branchDataMapper = new BranchDataMapper()
  private caseTypeDataMapper = new CaseTypeDataMapper()

  map = (rm: ClientRM) => {
    let mouDocument = null
    if (rm.mou_document !== null) mouDocument = new URLResource(rm.mou_document)

    let handler = this.userDataMapper.map(rm.handler)
    let claimTypes = rm.claim_types.map((it) => this.claimTypeDataMapper.map(it))
    let branches = rm.branches.map((it) => this.branchDataMapper.map(it))
    
    // Map case_types from API response
    let caseTypes: CaseType[] = []
    if (rm.case_types && Array.isArray(rm.case_types) && rm.case_types.length > 0) {
      const caseTypesArray = rm.case_types as any[]
      caseTypes = caseTypesArray.map((it: any) => {
        if (it.id) {
          const normalizedIt: any = { ...it }

          if (it.caseCategory && !it.case_category) {
            normalizedIt.case_category = it.caseCategory
          }
          if (it.internalTAT !== undefined && it.internal_TAT === undefined) {
            normalizedIt.internal_TAT = it.internalTAT
          }
          if (it.investigatorTAT !== undefined && it.investigator_TAT === undefined) {
            normalizedIt.investigator_TAT = it.investigatorTAT
          }
          if (it.requiredDocuments && !it.required_documents) {
            normalizedIt.required_documents = it.requiredDocuments
          }
          // Preserve isActive flag coming from /api/client so CaseType gets correct status
          if (typeof it.isActive !== 'undefined' && typeof normalizedIt.isActive === 'undefined') {
            normalizedIt.isActive = it.isActive
          }

          return this.caseTypeDataMapper.map(normalizedIt)
        } else {

          const stableId = `${rm.id}-${it.name || 'unknown'}`
          
          let caseCategoryCode = '';
          if (!it.caseCategory) {
            caseCategoryCode = '';
          } else if (typeof it.caseCategory === 'string') {
            caseCategoryCode = it.caseCategory;
          } else if (typeof it.caseCategory === 'object') {
            // Handle object format: {code: "LTI", name: "Low TAT Investigation", ...}
            caseCategoryCode = it.caseCategory.code || '';
          }
          
          return new CaseType(
            stableId,
            it.name || '',
            caseCategoryCode,
            it.internalTAT || 0,
            it.investigatorTAT || 0,
            it.capping || 0,
            it.services || [],
            it.requiredDocuments || [],
            it.isActive ?? true
          )
        }
      })
    }

    return new Client(rm.id, rm.name, rm.type, rm.disable, handler, rm.mou_expiry, mouDocument, claimTypes, branches, caseTypes)
  }
}

export default ClientDataMapper
